import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createDominoConfig,
  deleteDominoConfig,
} from '@store/venue/integrations/DominoConfigReducer'
import { SBRM, SBRMForm, useSBRMForm } from '@supplement-bacon/sbrm-react'
import MetadataKey from '@utils/MetadataKey'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'

export const DominoConfigForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.dominoConfig)
  const dispatch = useAppDispatch()
  const { getMetadata } = useSBRMForm()

  return (
    <SBRM.BaseEntityForm
      {...{
        ref,
        formProps: {
          ...formProps,
          initialValues: {
            ...formProps?.initialValues,
            venue: getMetadata(MetadataKey.Venue),
          },
        },
      }}
      error={error && String(error)}
      formActions={{
        create: Create,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createDominoConfig(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteDominoConfig(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

DominoConfigForm.displayName = 'DominoConfigForm'

export default DominoConfigForm
